<template>
  <el-dialog title="支付提示" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <p>微信支付未配置，请先在“ 设置-支付配置 ”页配置！</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false">知道了</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "payDialog",
  props: ["visible"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      dialogVisible: this.visible
    };
  }
};
</script>

